/* global axios */
import ApiClient from './ApiClient';

class LiveReportsAPI extends ApiClient {
  constructor() {
    super('live_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getConversationMetric(params = {}) {
    return axios.get(`${this.url}/conversation_metrics`, { params });
  }

  getGroupedConversations({ groupBy } = { groupBy: 'assignee_id' }) {
    return axios.get(`${this.url}/grouped_conversation_metrics`, {
      params: { group_by: groupBy },
    });
  }

  getVoiceCallMetrics(section) {
    return axios.get(`${this.url}/voice_call_metrics`, {
      params: { section },
    });
  }

  getVoiceCallHeatmap(params) {
    return axios.get(`${this.url}/voice_call_heatmap`, { params });
  }
}

export default new LiveReportsAPI();
